import * as types from '../actions/actionTypes.js';

export default (state, action) => {

    switch ( action.type ) {

        case types.SITESEARCH_FOCUSED:
            return Object.assign( {}, state, { hasFocus: true } );

        case types.SITESEARCH_BLURRED:
            return Object.assign( {}, state, { hasFocus: false} );

        case types.SITESEARCH_CHANGED:
            return Object.assign( {}, state, { currentSearchValue: action.searchValue } );

        case types.NAVIGATED_TO_SEARCHGALLERY:
            return Object.assign( {}, state, { currentSearchValue: (action.query || (action.meta || {}).query).q } );

        default:
            return state;
    }
}


export const getCurrentSearchValue = (state) => state.stolo.ui.siteSearch.currentSearchValue;



// WEBPACK FOOTER //
// ./src/reducers/ui.sitesearch.js